import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tipoContenidoComboReducer(state= initialState.tipoContenidoCombo, action){
	switch(action.type){
		case types.GET_TIPO_CONTENIDO_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}